import getHead from './../lib/getHead'
import parseGithubApiV3Response from './../lib/parseGithubApiV3Response'
import getBranchAndRepositoryDetails from './../lib/getBranchAndRepositoryDetails'

/**
 * Create a branch
 * @param {string} authToken
 * @param {string} currentBranchId
 * @param {string} newBranchName
 * @param {string} repoId
 * @returns {Promise<object>} A branch object
 */
async function createBranch(authToken, currentBranchId, newBranchName, repoId){

  var {
    repositoryOwner: repoOwner,
    repositoryName: repoName,
    branchName,
  } = await getBranchAndRepositoryDetails(authToken, currentBranchId)

  var head = await getHead(authToken, repoOwner, repoName, branchName)

  var result = await fetch(`https://api.github.com/repos/${repoOwner}/${repoName}/git/refs`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      "ref": `refs/heads/${newBranchName}`,
      "sha": head['object']['sha'],
    })
  })
  .then(parseGithubApiV3Response)

  return {
    id: result['node_id'],
    name: newBranchName,
    repositoryId: repoId,
  }
}

export default createBranch


// WEBPACK FOOTER //
// ./src/data/createBranch.js